import React, { useState } from "react";
import { DialogContent, Grid } from "@mui/material";
import { AxiosError } from "axios";

import { StandardDialogFooter } from "../../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import { mapValidationErrors } from "../../../../../../pages/user/settings/personal-info/personal-info.service";
import { CategoryModel } from "../../../../../../pages/shared/models/CategoryModel";
import { Message, MessageSections } from "../../../../../../pages/components/message/message";

import BarekamInputMultilingual from "../../../../../../pages/components/input-multilingual/barekam-input-multilingual";
import blogCategoryService from "../../../../../../services/blog-category-service";

const EditBlogCategory = ({ category, onCancel }: { category: CategoryModel, onCancel: () => void }) => {
    const [newCategory, setCategory] = useState(category);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    function handleChange(field: 'name', value: any) {
        setCategory(prevState => {
            return { ...prevState, [field]: value }
        })
    }

    function validateData() {
        const errors = {} as { [key: string]: string };
        if (newCategory.name === undefined || newCategory.name === null) {
            errors.name = 'required';
        }
        return errors;
    }

    function handleSave() {
        const errors = validateData();
        setErrors(errors);

        if (Object.keys(errors).length === 0) {
            if (category.id) {
                blogCategoryService.editBlogCategory(category.id, newCategory)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            } else {
                blogCategoryService.createBlogCategory(newCategory)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            }
        }
    }

    return (
        <>
            <DialogContent>
                <Grid container rowSpacing={'1rem'} columnSpacing={'1rem'}>
                    <Grid item xs={12}>
                    <BarekamInputMultilingual multilingualText={newCategory.name || {}}
                        labelKey={'name'}
                        field={'name'}
                        onChange={(name) => handleChange('name', name)}
                        errors={errors}
                    />
                    </Grid>
                </Grid>
            </DialogContent>

            <StandardDialogFooter onCancel={() => onCancel()}
                onSave={() => handleSave()}
                saveLabel={<Message messageKey={'save'} sectionId={MessageSections.MAIN} />} />
        </>
    );
}

export default EditBlogCategory;